import { render, staticRenderFns } from "./DayTemplateStuckedCard.vue?vue&type=template&id=97ae6ee4&scoped=true&"
import script from "./DayTemplateStuckedCard.vue?vue&type=script&lang=js&"
export * from "./DayTemplateStuckedCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ae6ee4",
  null
  
)

export default component.exports